import { getCountry, getCountryOrDefault } from 'utils/country';
import { appConfig } from 'config/appConfig';
import countries from 'constants/countries';
import isEmpty from 'lodash/isEmpty';
import paths from 'constants/paths';
import searchParams from '../constants/searchParams';
import { previewParam } from 'utils/externalAccess';

const allCountries = Object.values(countries).join('|');

export const matchRefreshPaths = (pathname) => {
  if (!pathname) return;
  const page = pathname.includes(paths.clientConfiguration)
    ? paths.clientConfiguration
    : `${paths.step}[${paths.steps.currentSituation}-${paths.steps.scorecard}]`;
  const regex = new RegExp(`(${allCountries})/(${page}{1}|${paths.redirect})/(\\d+)`, 'i');
  return regex.exec(pathname);
};

export const externalMatchRefreshPaths = (pathname) => {
  if (!pathname) return;
  const page = `step[${paths.steps.currentSituation}-${paths.steps.scorecard}]`;
  const regex = new RegExp(
    `(${allCountries})/${paths.externalAccess}/(${page}{1}|${paths.redirect})/(\\d+)`,
    'i',
  );
  return regex.exec(pathname);
};

export const isExceptionPath = (pathname, exceptionPaths) => {
  if (!pathname || isEmpty(exceptionPaths)) return;
  const regex = new RegExp(`/${exceptionPaths.join('|')}`, 'i');
  return !isEmpty(regex.exec(pathname));
};

export const isReportPagePath = (pathname) => {
  if (!pathname) return;
  const regex = new RegExp(`/${paths.report}`, 'i');
  return !isEmpty(regex.exec(pathname));
};

export const defineFooterUrl = (isExternalAccess, step, id, accessKey, preview) => {
  return isExternalAccess
    ? `/${getCountry()}/${paths.externalAccess}/${paths.step}${step}/${id}?${
        searchParams.accessKey
      }=${accessKey}${previewParam(preview)}`
    : `/${getCountry()}/${paths.step}${step}/${id}`;
};

export const getFullPathOrHome = (path) =>
  path ? `/${getCountry()}/${path}` : `/${getCountryOrDefault()}`;

export const getNotFoundPagePath = () => getFullPathOrHome(paths.notFound);

export const getUrl = (path) => `${appConfig.PUBLIC_URL}${getFullPathOrHome(path)}`;

export const openFullPathInNewTab = (path) => {
  const fullPath = getFullPathOrHome(path);
  const url = `${appConfig.PUBLIC_URL}${fullPath}`;
  openUrlInNewTab(url);
};

export const openUrlInNewTab = (url) => window.open(url, '_blank');
